export default __webpack_public_path__ + "static/article-thumbnail-03-5a74dee6d7f6fcda3455fa2782171090.png";